export default __webpack_public_path__ + "static/media/INTHEMOOD_ABOUT_PAGE_TEXT_LOGO.b0b0a193.jpg";